import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { DialogActivities } from "../../../components/common/DialogActivities";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	dialogTwo: 2,
	dialogTwop2: 2.5,
	modalsubactivityOne: 3,
	gameSubactivityOne: 4,
	dialogthree: 5,
	modalSubactivityTwo: 6,
	gameSubactivityTwo: 7,
	dialogfour: 8,
	dialogfive: 9,
	dialogsix: 10,
	modalSubactivityThree: 11,
	gameSubactivityThree: 12,
	dialogseven: 13,
	dialogeight: 14,
	activityInfo: 20,
	panelinformationone: 21,
	panelinformationtwo: 22,
};
export const SubtopicTwoActivityTwo = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema2], 2);

	useEffect(() => {
		if (loaded) {
			console.log("subtema two Activity two");
			ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicTwo.activityTwo.completeFrenteo, () => {
		setUiToShow(steps.dialogthree);
	});
	ObserverEmitter.on(EVENTS.subtopicTwo.activityTwo.completeFondeo, () => {
		setUiToShow(steps.dialogseven);
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicTwo.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{[steps.gameSubactivityOne, steps.gameSubactivityTwo].includes(uiToShow) && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.gameSubactivityOne && (
				<DialogActivities
					isTimeout={true}
					dialog={"Coloca los productos que ya se encontraban en lo anaqueles al frente"}
					percentage={"100%"}
				></DialogActivities>
			)}
			{uiToShow === steps.gameSubactivityTwo && (
				<DialogActivities
					isTimeout={true}
					dialog={"Ordena los productos usando PEPS coloca los productos que ya se encontraban en los anaqueles al frente y los nuevos atrás."}
					percentage={"100%"}
				></DialogActivities>
			)}

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Frenteo, fondeo, acomodo y PEPS." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Una vez observadas las áreas que requerían de aseo, es momento de aprender los siguientes puntos: Frenteo, Fondeo, Acomodo y PEPS (Primeras Entradas Primeras Salidas)."
						}
						percentage={"10%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.activityInfo);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.activityInfo && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Abasto en tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"El frenteo es uno de los pasos del orden y el aseo. Consiste en organizar los productos de forma visible. Si encuentras espacios vacíos en los estantes, asegúrate de frentear los productos."
					}
					percentage={"20%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a03)
						setUiToShow(steps.dialogTwop2);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTwop2 && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"A continuación veremos como la forma correcta para aplicar el frenteo."}
					percentage={"20%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a04)
						setUiToShow(steps.modalsubactivityOne);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.modalsubactivityOne && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"Observa analiza y señala los lugares que requieren de un frenteo. Procura que la marca siempre quede visible a los ojos del Cliente."
					}
					percentage={"30%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						ObserverEmitter.emit(EVENTS.subtopicTwo.activityone.moveCamareGameOne);
						setUiToShow(steps.panelinformationone);
					}}
				></DialogBarNew>
			)}

			{uiToShow === steps.panelinformationone && (
				<PanelInstrucionHands
					text="Toca encima de el producto que desees acomodar, después..."
					action={() => {
						setUiToShow(steps.panelinformationtwo);
					}}
					img={imgInstruction.sub2_act_2_01}
				/>
			)}

			{uiToShow === steps.panelinformationtwo && (
				<PanelInstrucionHands
					text="Toca encima de el lugar en el anaquel donde deseas acomodarla"
					action={() => {
						setUiToShow(steps.gameSubactivityOne);
					}}
					img={imgInstruction.sub2_act_2_02}
				/>
			)}

			{uiToShow === steps.dialogthree && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={5}
					dialogModal="Un buen frenteo, fondeo y acomodo ayudan a que la tienda se vea ordenada y bien abastecida."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a05)
						ObserverEmitter.emit(EVENTS.subtopicTwo.activityTwo.moveCamareTable);
						setUiToShow(steps.dialogfour);
					}}
				/>
			)}
			{uiToShow === steps.dialogfour && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={`Vamos por muy buen camino recuerda que además del frenteo y fondeo debemos practicar PEPS que significa "Primeras Entradas Primeras Salidas".`}
					percentage={"40%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a06)
						setUiToShow(steps.dialogfive);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogfive && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={`PEPS es frentear el producto que se encontraba primero y con fecha de caducidad próxima a vencer y es fondear el nuevo producto detrás con una fecha de caducidad más lejana a vencer.`}
					percentage={"70%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub02.sub2_act2_a07)
						setUiToShow(steps.modalSubactivityTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.modalSubactivityTwo && (
				<DialogBarNew
					titulo={"Actividad. PEPS"}
					dialog={
						"Ordena los productos usando PEPS coloca los productos que ya se encontraban en lo anaqueles al frente y los nuevos atrás."
					}
					percentage={"90%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						ObserverEmitter.emit(EVENTS.subtopicTwo.activityTwo.initFondeo);
						setUiToShow(steps.gameSubactivityTwo);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogseven && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={5}
					dialogModal="PEPS es de suma importancia, ya que evitaremos pérdidas."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 2,
								pointsWin: 10,
								subtema: tasksId.tema1.activities.subtema2,
							})
						);
						navigator("/home1/tema1/subtema2/activitythree");
					}}
				/>
			)}
		</>
	);
};
